import React from "react";
import classnames from "classnames";
import tailwindExt from "styles/tailwindExtensions";
import Text from "../../ui/Text";

const tailwindExtensions = tailwindExt.tailwindExtensions;

const COLOR_CONFIG = {
  critical: {
    bgColor: tailwindExtensions.colors.critical,
    fontColor: "text-white",
    fontWeight: "font-medium",
    iconName: "fa-warning",
  },
  warning: {
    bgColor: tailwindExtensions.colors.warning,
    fontColor: "text-black",
    fontWeight: "font-medium",
    iconName: "fa-warning",
  },
  default: {
    bgColor: tailwindExtensions.colors["green-primary"],
    fontColor: "text-black",
    fontWeight: "font-medium",
  },
};

const Icon = ({ iconName }) => {
  if (iconName) {
    return <i className={`mr-1 fas ${iconName} self-start pt-1 mr-2`} />;
  }
  return null;
};

const Title = ({
  title,
  expanded = false,
  showArrow = true,
  onClick,
  isModal,
  color,
  iconOverride,
  style = {},
  type = "default",
  ButtonComponent,
}) => {
  const { fontColor, bgColor, fontWeight, iconName } = COLOR_CONFIG[type];
  const WrapperTag = ButtonComponent || !onClick ? "div" : "button";
  const tagType = ButtonComponent ? {} : { type: "button" };

  return (
    <WrapperTag
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...tagType}
      className={classnames(
        "flex items-center h-full px-4 py-4 relative z-20 bg-critical outline-none justify-between w-full border-0",
        { "cursor-pointer": onClick },
        { "cursor-default": !onClick },
        { "rounded-t-sm rounded-b-none": expanded || isModal },
        { "rounded-sm": !expanded && !isModal }
      )}
      style={{ outline: 0, backgroundColor: color || bgColor, ...style }}
      onClick={onClick}
    >
      <div className="flex flex-col md:flex-row items-center w-full justify-between">
        <div
          className={`flex flex-row items-center w-full md:w-auto ${fontColor}`}
        >
          <Icon iconName={iconOverride || iconName} />
          <Text weight={fontWeight} className="inline pr-2 text-left">
            {title}
          </Text>
        </div>
        {ButtonComponent}
      </div>
      {showArrow && (
        <i
          className={`fas fa-chevron-${
            expanded ? "down" : "right"
          } ${fontColor}`}
        />
      )}
    </WrapperTag>
  );
};

export default Title;
